import RequestForm from "@/features/foot-watch/components/forms/RequestForm";
import { createFileRoute } from "@tanstack/react-router";
import { FilePlus } from "lucide-react";
import PrettyRequestWrapper from "../../components/common/PrettyRequestWrapper";

export const Route = createFileRoute("/forms/request")({
    component: () => (
        <PrettyRequestWrapper
            icon={<FilePlus className="mb-2 w-10 h-10 text-indigo-500" />}
            title="Request a New Questionnaire"
            description="Need a new questionnaire for your workflow? Fill out the form below and our team will review your request."
        >
            <RequestForm />
        </PrettyRequestWrapper>
    ),
});
